import type { HostConfigurationDto } from "../../types/HostConfigurationDto";
import type { HostConfigurationEntity } from "../../types/HostConfigurationEntity";

export const HostConfigurationEntityToDto = ({ ...rest }: Readonly<HostConfigurationEntity>): HostConfigurationDto => {
    return {
        ...rest,
    };
};
